import { ModalWindow, UIHeading2 } from '@cian/ui-kit';
import { useContext } from 'react';
import { ModalContext } from 'shared/utils/modalContext';
import { useModalForm } from 'shared/hooks/useModalForm';
import { IForm } from 'shared/types/form';

type TModalFormContainerProps = IForm;

export const ModalFormContainer: React.FC<TModalFormContainerProps> = props => {
  const { backToForm, onClose } = props;

  const modalVisible = useContext(ModalContext);

  const content = useModalForm(
    {
      ...props,
    },
    backToForm,
  );

  return (
    <ModalWindow
      onClose={onClose}
      open={modalVisible}
      header={<UIHeading2>Оставьте заявку и менеджер вам перезвонит</UIHeading2>}
      content={content}
    />
  );
};
